import { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { gql, useLazyQuery } from '@apollo/client';

import { useDispatch } from 'Hooks';
import * as actions from 'actions';
import { venueQuery, venueQueryVariables } from './__queries__';
import { useShoppingCart } from 'Components/ShoppingCartUniverse';

const VENUE_QUERY = gql`
  query venueQuery($id: ID!) {
    venue: Venue(id: $id) {
      id
      minimumPickupWaitTime
      name
      bookingServiceId
      minimumDeliveryFee
      supportEmail
      availabilities {
        id
        dayOfWeek
        timeRange {
          id
          start
          end
        }
      }
      deliveryRates {
        id
        zip
        polygon
        fee {
          id
          price {
            id
            percentageVAT
            amount
          }
        }
        message {
          id
          se
          en
        }
      }
      location {
        id
        name
        lat
        long
      }
    }
  }
`;

const VenueManager = () => {
  const params = useParams<{ venue_id?: string }>();
  const venueId = params?.venue_id || '';
  const dispatch = useDispatch();
  const { serviceType } = useShoppingCart();
  const { push } = useHistory();
  const location = useLocation();

  const [getVenueData, { data, loading }] = useLazyQuery<venueQuery, venueQueryVariables>(
    VENUE_QUERY,
    {
      variables: {
        id: venueId,
      },
    },
  );

  useEffect(() => {
    if (venueId && serviceType) {
      getVenueData();
    } else if (!venueId || (!serviceType && location.pathname.includes('order'))) {
      push('/');
    }
  }, [venueId, serviceType]);

  useEffect(() => {
    if (!loading && data) {
      dispatch(actions.setVenue(data.venue));
    }
  }, [data, loading]);
};

export default VenueManager;
